import React from "react";

export default function Footer() {
  return (
    <div className="tailwind-wrapper">
      <div className="fixed left-0 bottom-0 w-full pb-[5px] bg-black text-white text-center">
        <span>
          Persons under 18 must not participate in any betting, gaming or
          lottery activity.
        </span>
      </div>
    </div>
  );
}
